module.exports = __webpack_public_path__ + "static/media/valor3_2.ea2dd959.png";